var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1159 9.09162C13.1159 7.0351 14.8407 6.04001 14.907 5.97366C13.9119 4.58051 12.4524 4.38148 11.9218 4.31515C10.6613 4.18247 9.40083 5.04489 8.80374 5.04489C8.14036 5.04489 7.14527 4.31515 6.08381 4.31515C4.69066 4.31515 3.4302 5.11123 2.70046 6.37167C1.24098 8.89259 2.30242 12.6077 3.69556 14.6642C4.4253 15.6593 5.22139 16.7871 6.28283 16.7207C7.34425 16.6544 7.74231 16.0574 9.00277 16.0574C10.2632 16.0574 10.5949 16.7207 11.7227 16.7207C12.8505 16.7207 13.5802 15.7257 14.2436 14.7306C15.0397 13.6028 15.3714 12.475 15.3714 12.4087C15.3051 12.3423 13.1159 11.5462 13.1159 9.09162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0596 2.98857C11.5903 2.25883 11.9883 1.33006 11.922 0.334961C11.1259 0.401301 10.0645 0.865684 9.53375 1.59542C9.00305 2.19248 8.53865 3.18759 8.67134 4.11635C9.53375 4.18269 10.4625 3.65197 11.0596 2.98857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.0a19463a2beaff68f438f01fec9b34af.svg";
export { ForwardRef as ReactComponent };